import React, { Component } from "react";
import "./creditcardhome.css";
import { t } from "i18next";
import * as Bl from "../../../businesslogic";
import creditCard from "../../../assets/svgs/credit_card.svg";
import {
  BreadCrumb,
  Button,
  TitleView,
  SideModel,
} from "../../components";
import { getLiabilityPathName, getUserId} from "../../common";
import { LIABILITIES_CATEGORY } from "../../constants";

const newLiability = {
  userid: "",
  liabilitiescategory: LIABILITIES_CATEGORY.CREDITCARD_BALANCE,
  description: "",
  loanissuedby: "",
  maturityyear: 0,
  currentvalue: 0,
  maturityage: 0,
  isincludefinancialplan: false
};
class CreditCardHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDrawer: false,
      liabilityData: [],
      newLiabilityData: new Bl.Liability({...newLiability, userid: getUserId()}),
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddProperty() {
    this.props.navigate("/creditcarddetail", {
      state: { liabilityData: this.state.newLiabilityData, isEditView: false },
    });
  }


  renderNavView() {
    const items = getLiabilityPathName("CreditCard");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("creditTitle");
    return <TitleView title={title} />;
  }

  renderProfileView() {
    return (
      <div className="chome_profile_view">
        <img src={creditCard} alt={t("creditTitle")} className="chome_icon" />
        <div className="chome_info_view">{t("creditInfo")}</div>
        <div className="chome_add_property">
          <Button
            buttonName={t("creditButton")}
            onPressButton={this.onPressAddProperty.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  renderContentView() {
    return (
      <div className="chome_content_view">
        {this.renderTitleView()}
        {this.renderProfileView()}
      </div>
    );
  }

  render() {
    return (
      <div className="chome_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {/* {this.renderDrawerContent()} */}
      </div>
    );
  }
}

export default CreditCardHome;
